import isObject from 'lodash-es/isObject'

export function parseNotificationProps(value, t) {
  if (isObject(value)) {
    return value
  } else {
    return {
      title: t(value),
    }
  }
}
